import { login } from "@/api/user";
import { getUserIdApi } from "@/api/auth-login";
import { getToken, setToken, removeToken, getName, setName, removeName, getPhone, setPhone, removePhone } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    name: getName(),
    phone: getPhone()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_PHONE: (state, phone) => {
        state.phone = phone;
    }
};

const actions = {
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ username, password })
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        let temp = data;
                        commit("SET_NAME", temp.username);
                        setName(temp.username);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                        setPhone(temp.comUscc);
                        commit("SET_PHONE", temp.comUscc);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // 统一认证登录
    authLogin({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            /* getUserIdApi(userInfo)
                .then((response) => {
                    const { data } = {response};
                    if (data) {
                        let temp = data;
                        commit("SET_NAME", temp.username);
                        setName(temp.username);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                        commit("SET_PHONE", temp.comUscc);
                        setPhone(temp.comUscc);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                }); */
                const { data } = {
                    "msg": "操作成功",
                    "code": "200",
                    "data": {
                        "departmentName": "北京一证通测试有限二公司",
                        "recommenderEmail": null,
                        "comType": "1",
                        "comUscc": "WNRW1W8CG",
                        "typeOther": null,
                        "isThree": 0,
                        "updateUser": null,
                        "updateTime": "2025-07-18 11:07:09.000000",
                        "departmentType": null,
                        "type": null,
                        "domainId": "11",
                        "comAddress": "第三方的你",
                        "password": null,
                        "comTypeName": "高校",
                        "createTime": "2025-07-09 17:12:35.000000",
                        "recommenderName": "小周",
                        "recommenderContact": "17312312312",
                        "domainName": "东城区",
                        "createUser": null,
                        "id": "1942874514161537024",
                        "username": "北京一证通测试有限二公司"
                    }
                };
                if (data) {
                    // 从 sessionStorage 获取 Authorization
                    const authorization = sessionStorage.getItem("Authorization");
                    // 从 sessionStorage 获取 client-userInfo 并解析
                    const clientUserInfoStr = sessionStorage.getItem("client-userInfo");
                    let clientUserInfo = null;
                    if (clientUserInfoStr) {
                        try {
                            clientUserInfo = JSON.parse(clientUserInfoStr);
                        } catch (e) {
                            console.error("解析 client-userInfo 失败:", e);
                        }
                    }
                    
                    // 使用 sessionStorage 中的值
                    const username = clientUserInfo?.cn || "";
                    const token = authorization || "";
                    const phone = clientUserInfo?.idCardNumber || "";
                    
                    commit("SET_NAME", username);
                    setName(username);
                    commit("SET_TOKEN", token);
                    setToken(token);
                    commit("SET_PHONE", phone);
                    setPhone(phone);
                }
                resolve(data);
        });
    },
    resetToken({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            commit("SET_PHONE", "");
            removeToken();
            removeName();
            removePhone();
            sessionStorage.removeItem("client-userInfo");
            sessionStorage.removeItem("Authorization");
            localStorage.clear();
            sessionStorage.clear();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
